function unescape(str: string) {
    return (str + '==='.slice((str.length + 3) % 4))
        .replace(/-/g, '+')
        .replace(/_/g, '/');
}

function escape(str: string) {
    return str.replace(/\+/g, '-')
        .replace(/\//g, '_')
        .replace(/=/g, '');
}

export function encodeUrlBase64(object: any, sessionID: string) {
    if (!sessionID) {
        throw "Invalid sessionID";
    }
    object.SessionID = sessionID;
    return escape(btoa(JSON.stringify(object)));
}

export function decodeUrlBase64(urlString: string) {
    return JSON.parse(atob(unescape(urlString)));
}
